<template>
	<div id="cardDetails" class="container">
		<el-breadcrumb separator-class="el-icon-arrow-right" class='mbx'>
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>{{routeName[0].name}}</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="msgBox" v-if="$route.query.status != 1">
			<h3>{{spjs.bigtitle}}</h3>
			<p class="title">{{spjs.smalltitle}}</p>
			<ul>
				<li>建议人群：</li>
				<li>{{spjs.jy}}</li>
			</ul>
			<ul>
				<li>清单档位：</li>
				<li><span>标准</span>· 全国统一销售价</li>
			</ul>
			<ul>
				<li>保障开始日期：</li>
				<li><b>{{spjs.time}}</b></li>
			</ul>
			<ul>
				<li>价格：</li>
				<li><b>￥{{spjs.money}}</b> <i class="qi">起</i></li>
			</ul>
			<div class="login">
				<h4>我是旅行社，我想销售此清单</h4>
				<p class="daili"><span>*</span> 本清单仅提供旅行社代理销售 </p>
				<el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px">
					<el-form-item label="机构名称:" class="is-required" prop="jgName">
						<el-input v-model="ruleForm2.jgName" autocomplete="off" placeholder="请输入机构名称"></el-input>
					</el-form-item>
					<el-form-item label="联系人姓名:" class="is-required" prop="lxrName">
						<el-input v-model="ruleForm2.lxrName" autocomplete="off" placeholder="请输入联系人姓名"></el-input>
					</el-form-item>
					<el-form-item label="联系人电话:" class="is-required" prop="lxrPhone">
						<el-input v-model.number="ruleForm2.lxrPhone" placeholder="请输入联系人电话"></el-input>
					</el-form-item>
					<el-form-item label="机构地址:" class="is-required" prop="contact2">
						<el-input v-model.number="ruleForm2.contact2" autocomplete="off" placeholder="请输入机构地址"></el-input>
					</el-form-item>
					<el-form-item label="组织机构代码:">
						<el-input v-model="ruleForm2.lxrCode" autocomplete="off" placeholder="请输入组织机构代码"></el-input>
					</el-form-item>
					<el-form-item label="所属分支机构:">
						<el-select v-model="ruleForm2.lxrFenzhi" class="choose" placeholder="请选择所属分支机构" style='width: 100%;'>
							<el-option
							  v-for="(item,index) in fenzhiList"
							  :key="index"
							  :label="item.name"
							  :value="item.id">
							</el-option>
						  </el-select>
					</el-form-item>
					<el-form-item>
						<el-button class='btn' style='color: white;' type="primary" @click="submitForm('ruleForm2')">申请使用</el-button>
						<el-button class='btn' ><router-link to='/login'>已有账号，登录我的清单销售平台</router-link></el-button>
						<a class="blue" href="http://www.chinatourins.com/" target="_blank">旅游保险网用户点此进入</a>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div v-else  class="msgBox msgBox1">
			<h3>{{spjs.bigtitle}}</h3>
			<p class="title">{{spjs.smalltitle}}</p>
			<ul>
				<li>建议人群：</li>
				<li>{{spjs.jy}}</li>
			</ul>
			<ul>
				<li>清单档位：</li>
				<li><span>标准</span>· 全国统一销售价</li>
			</ul>
			<ul>
				<li>保障开始日期：</li>
				<li><b>{{spjs.time}}</b></li>
			</ul>
			<ul>
				<li>价格：</li>
				<li><b>￥{{spjs.money}}</b> <i class="qi">起</i></li>
			</ul>
		</div>
		<div class="guize">
			<ul class="tab">
				<li :class="{active:tabIndex == 0}" @click="tabIndex = 0"><a>商品介绍</a></li>
				<li :class="{active:tabIndex == 1}" @click="tabIndex = 1"><a>救援服务项</a></li>
				<li :class="{active:tabIndex == 2}" @click="tabIndex = 2"><a>免责条款</a></li>
				<li :class="{active:tabIndex == 3}" @click="tabIndex = 3"><a>商务联系</a></li>
			</ul>
			<template>
				<div class="xiangqing" v-show="tabIndex == 0">
					<p class="til">商品介绍</p>
					<ul>
						<li v-for="item in spjs.products">{{item.name}}</li>
					</ul>
				</div>
				<div class="xiangqing" v-show="tabIndex == 1">
					<p class="til">(一) {{spjs.jyfwx.title}}</p>
					<ul>
						<li v-for="item in spjs.jyfwx.list">{{item.name}}</li>
					</ul>
					<p class="til">(二) {{spjs.jyfwx1.title}}</p>
					<ul>
						<li v-for="item in spjs.jyfwx1.list">{{item.name}}</li>
					</ul>
				</div>
				<div class="xiangqing" v-show="tabIndex == 2">
					<template v-for="(item,index) in spjs.mztk">
						<p class="til">{{index+1}}. {{item.title}}</p>
						<ul>
							<li v-for="item1 in item.list">{{item1.name}}</li>
						</ul>
					</template>
				</div>
				<div class="xiangqing lianxi" v-show="tabIndex == 3">
					<p>公司：江泰救援服务有限公司</p>
					<p>地址：北京市门头沟区莲石湖西路98号院9号楼江泰大厦</p>
					<p>电话：+86 10 68188889</p>
					<p>邮箱：jiuyuan@jiangtai.com</p>
					<p>网站：www.dajiuxing.com.cn</p>
					<p>如果您有任何疑问或者有合作需求，欢迎随时与我们联系，期待您的来电！</p>
				</div>
			</template>

		</div>
	</div>
</template>

<script>
	import cardData from './cardData.json'
	import cardData1 from './cardData1.json'
	import cardData2 from './cardData2.json'
	import cardData3 from './cardData3.json'
	import { applyFor,getFenzhi } from '@/axios/api.js'
	export default {
		data() {
			var checklxrPhone = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('电话不能为空！'));
				}
				if (!Number.isInteger(value)) {
					callback(new Error('请输入数字值'));
				} else {
					callback();
				}
			};
			var validatejgName = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入机构名称！'));
				} else {
					if (this.ruleForm2.lxrName !== '') {
						this.$refs.ruleForm2.validateField('lxrName');
					}
					callback();
				}
			};
			var validatejgName2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再联系人姓名！'));
				} else {
					callback();
				}
			};
			var validatejgCode = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入组织机构代码！'));
				} else {
					callback();
				}
			};
			var validatejgFenzhi = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请选择分支机构！'));
				} else {
					callback();
				}
			};
			var contact2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请选择输入地址！'));
				} else {
					callback();
				}
			};
			return {
				routeName: '',
				ruleForm2: {
					jgName: '',
					lxrName: '',
					lxrPhone: '',
					lxrCode:'',
					lxrFenzhi:'',
					contact2:''
				},
				rules2: {
					jgName: [{
						validator: validatejgName,
						trigger: 'blur'
					}],
					lxrName: [{
						validator: validatejgName2,
						trigger: 'blur'
					}],
					lxrPhone: [{
						validator: checklxrPhone,
						trigger: 'blur'
					}],
					lxrCode:[{
						validator:validatejgCode,
						trigger:'blur'
					}],
					lxrFenzhi:[{
						validator:validatejgFenzhi,
						trigger:''
					}],
					contact2:[{
						validator:contact2,
						trigger:''
					}],
				},
				spjs:{},
				tabIndex:0,
				fenzhiList:[]
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.applyFor()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			applyFor(){
				var data={
					name:this.ruleForm2.jgName,
					contactName:this.ruleForm2.lxrName,
					contact1:this.ruleForm2.lxrPhone,
					orgCode:this.ruleForm2.lxrCode,
					parentId:this.ruleForm2.lxrFenzhi,
					contact2:this.ruleForm2.contact2
				}
				applyFor(data)
				.then(res => {
					console.log(res)
					if(res.data.code == 100000){
						this.$message({
						  message: '申请成功，请您耐心等待我们后台审核通过！',
						  type: 'success'
						});
						this.$refs['ruleForm2'].resetFields();
					}
				})
				.catch( err => {
					console.log(err)
				})
			},
			getFenzhi(){
				getFenzhi()
				.then(res =>{
					if(res.data.code==0){
						this.fenzhiList=res.data.obj;
					}

				})
				.catch( err => {
					console.log(err)
				})
			}
		},
		mounted() {
			this.getFenzhi();
		},
		created(){
			this.routeName = this.$route.meta;
			if(this.$route.query.tag == '旅行社专属救援清单'){
				this.spjs=cardData.list[this.$route.query.index];
			}else if(this.$route.query.tag == '个人用户救援清单'){
				this.spjs=cardData1.list[this.$route.query.index];
			}else if(this.$route.query.tag == '企业救援清单'){
				this.spjs=cardData2.list[this.$route.query.index];
			}else if(this.$route.query.tag == '银行专属救援清单'){
				this.spjs=cardData3.list[this.$route.query.index];
			}
		}
	}
</script>

<style scoped="scoped">
	.msgBox * {
		color: #333333;
	}

	.mbx {
		padding: 20px 0;
	}

	.msgBox {
		background: white;
		padding: 20px;
		position: relative;
		margin-bottom: 30px;
		height: 680px;
	}

	.msgBox h3 {
		font-size: 20px;
	}

	.msgBox .title {
		line-height:60px;
		max-width: 500px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.msgBox>ul {
		overflow: hidden;
	}

	.msgBox>ul li {
		float: left;
		line-height: 60px;
		color: #666;
	}

	.msgBox>ul li:first-child {
		width: 120px;
		text-align: right;
	}

	.msgBox>ul li span {
		padding: 3px 10px;
		background: #00abfa;
		color: white;
		border-radius: 3px;
		margin-right: 20px;
	}

	.msgBox>ul li b {
		color: #fea100;
		font-size: 20px;
	}

	.msgBox .qi {
		color: #fea100;
		font-size: 14px;
		font-style: normal;
	}

	.login {
		position: absolute;
		top: 20px;
		right: 20px;
		width: 500px;
		padding: 20px;
		box-shadow: 0 0 20px rgba(63,180,253,0.2);
		padding-bottom: 0;
	}
	.login h4{text-align: center;font-size: 20px;}
	.login .daili{text-align: center;line-height: 40px;}
	.login .daili span{color: red;font-size: 14px;}
	.btn{display: block;width: 90%;margin: 0 auto;margin-bottom: 20px;}
	.guize{background: white;padding: 20px;}
	.guize .tab{overflow: hidden;width: 440px;margin: 0 auto;}
	.guize .tab li{float: left;line-height: 50px;cursor: pointer;}
	.guize .tab li >a{border-right: 1px solid #eee;width: 100%;padding: 0 20px;line-height: 15px;}
	.guize .tab li:last-child >a{border: none;}
	.guize .tab li.active{border-bottom: 2px solid #00ABFA}
	.guize .tab li.active a{color: #00ABFA;}
	.xiangqing .til{margin-bottom: 10px;margin-top: 20px;line-height: 30px;}
	.xiangqing ul{margin-left: 10px;}
	.xiangqing li{color: #666;line-height: 30px;position: relative;padding-left: 10px;font-size: 14px;}
	.xiangqing li:before{content: '';display: block;width: 5px;height: 5px;background: #fea100;border-radius: 50%;position: absolute;top: 13px;left: 0;}
	.lianxi p{line-height: 30px;padding-left: 100px;}
	.msgBox1{height: auto;}
	.blue{display: block;text-align: center;color: #409EFF;}
</style>



// WEBPACK FOOTER //
// src/views/home/details.vue